import { render, staticRenderFns } from "./RevwBody.vue?vue&type=template&id=2f862486"
import script from "./RevwBody.vue?vue&type=script&lang=js"
export * from "./RevwBody.vue?vue&type=script&lang=js"
import style0 from "./RevwBody.vue?vue&type=style&index=0&id=2f862486&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VRating,VRow,VSpacer})
